import React from "react";
import styled from "styled-components";
import css from "@styled-system/css";
import { Picture, TwoOne } from "../Layout/Layout";
import { Description } from "../Typography";
import { Button } from "../guide/Stream/styled";

import {
  Card as GuideCard,
  Description as GuideCardDescription,
  Button as GuideCardButton,
  Picture as GuideCardPicture,
} from "../Cards/GuideCard";

export const Root = styled("div")(css({}));

export const Platform = ({
  url,
  title,
  description,
  image,
  children,
  guideNo,
  guideText,
  guideImage,
}) => (
  <>
    <TwoOne>
      <Description>
        <h3>{title}</h3>
        <p>{description}</p>
        {url && (
          <Button as="a" href={url}>
            Перейти
          </Button>
        )}
      </Description>
      {image && (
        <Picture>
          <img alt="" src={image} style={{ width: "100%" }} />
        </Picture>
      )}
      {guideNo && (
        <GuideCard>
          <GuideCardPicture src={guideImage} />
          <GuideCardDescription>{guideText}</GuideCardDescription>
          <GuideCardButton as="a" href={`/guide/${guideNo}/`}>
            Перейти
          </GuideCardButton>
        </GuideCard>
      )}
    </TwoOne>
    <TwoOne>
      <Description>{children}</Description>
    </TwoOne>
  </>
);
